import { useEffect } from 'react';
import { throttle } from 'underscore';
import { dispatcher } from 'dispatcher';

import { EVENT_UPDATE_DOM, DELAY_UPDATE_DOM } from 'js/components/system/Page/buzz/constants';

export const useEventUpdateDom = (layoutRef) => {
    useEffect(() => {
        if (!layoutRef?.current) {
            return;
        }

        const throttledDispatch = throttle(() => {
            dispatcher.dispatch(EVENT_UPDATE_DOM);
        }, DELAY_UPDATE_DOM);

        const observer = new MutationObserver(throttledDispatch);

        observer.observe(layoutRef.current, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, [layoutRef]);
};
